<template>
  <LayoutContainer :id="data.cssId">
    <UtilityHeadline
      v-if="data.headlineH2"
      :class="`dbc-text-color-${data.headlineH2Color}`"
      :text="data.headlineH2"
      :level="2"
      :aos="{ fadeDirection: 'fade-right', delay: 300 }"
    />

    <UtilityText
      v-if="data.text"
      :class="`dbc-text-color-${data.textColor} w-[77%] max-mobile:w-auto`"
      :text="data.text"
      :aos="{ fadeDirection: 'fade-right', delay: 500 }"
    />
    <div class="flex gap-xs flex-wrap items-stretch m-auto">
      <div
        class="w-[18rem] max-mobile:w-full"
        v-for="tariff in tariffs?.filter((tariff) => !tariff.hidden)"
        :key="tariff.id"
        :id="`tariff-${tariff.id}`"
      >
        <TariffCard :tariff="tariff" :hide-buttons="data.hideButtons" />
      </div>
      <DbcBanner
        v-if="hasTariffError"
        id="errorBanner"
        :severity="'warn'"
        :message="$t('dbc-registration-tariff-error')"
      />
    </div>
  </LayoutContainer>
</template>

<script setup lang="ts">
const props = defineProps<{
  content: ContentTariff
}>()
const data = normalizeTariffs(props.content)

const runtimeConfig = useRuntimeConfig()
const client = runtimeConfig.public.client

const { locale } = useI18n()

const hasTariffError = ref(false)

const { data: tariffs, error } = await useFetchTariffs(
  client,
  locale.value,
  data.actioncode
)

if (error.value) {
  await fetchTariffs(data.actioncode, locale.value).then((response) => {
    if (response.status === 200) {
      tariffs.value = response._data.data
      hasTariffError.value = false
    } else {
      hasTariffError.value = true
    }
  })
}
</script>
